import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { GestioneProdottiSoftwareComponent } from './gestione-prodotti-software.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    DialogModule,
    ToastModule
  ],
  exports: [
    GestioneProdottiSoftwareComponent
  ],
  declarations: [
    GestioneProdottiSoftwareComponent
  ]
})
export class ProdottiSoftwareModule { }
